import Head from 'next/head';
import React from 'react';

import { localitySchema } from './HeadStructuredData';

interface ILocalityHeadProps {
  cityName: string;
  regionCode: string;
  stateName: string;
  rvParkDestination: string;
  hikingTrails: string[];
}

export const LocalityHead = ({
  cityName,
  regionCode,
  stateName,
  rvParkDestination,
  hikingTrails,
}: ILocalityHeadProps) => {
  const schemaData = localitySchema({
    cityName,
    regionCode,
    stateName,
    rvParkDestination,
    hikingTrails,
  });
  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
    </Head>
  );
};
